module.exports = __webpack_public_path__ + "static/media/PatriciaGeraghty@3x.852cf2de.png";